import { render, staticRenderFns } from "./money-send.vue?vue&type=template&id=12499225&"
import script from "./money-send.vue?vue&type=script&lang=js&"
export * from "./money-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12499225')) {
      api.createRecord('12499225', component.options)
    } else {
      api.reload('12499225', component.options)
    }
    module.hot.accept("./money-send.vue?vue&type=template&id=12499225&", function () {
      api.rerender('12499225', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/money-send.vue"
export default component.exports